import gql from "graphql-tag"

import fullTeam from "../fragments/fullTeamV4"

export default gql`
  mutation CreateTeam($tenantId: String!, $data: TeamInput!) {
    createTeam(tenantId: $tenantId, data: $data) {
      ...fullTeam
      users(totalOnly: true) {
        total
      }
    }
  }
  ${fullTeam}
`
